import type { ProdutoCatalogo, ItemAdicionarComanda } from '@/api';

function gramasDe(pesoKg: number): number {
  return Math.round(pesoKg * 1000);
}

function centavosPorPeso(produto: ProdutoCatalogo, gramas: number): number {
  const centavosPorKg = Math.round(produto.valor * 100);
  return Math.ceil((gramas * centavosPorKg) / 1000);
}

export function formatarPesoKg(kg: number): string {
  return `${(gramasDe(kg) / 1000).toFixed(3).replace('.', ',')} kg`;
}

export function calcularItemPesado(produto: ProdutoCatalogo, pesoKg: number): ItemAdicionarComanda {
  const gramas = gramasDe(pesoKg);
  const centavos = centavosPorPeso(produto, gramas);

  const livre = produto.produtoLivre;
  
  if (livre && Math.round(livre.valor * 100) < centavos) {
    return {
      idProduto: livre.id,
      nome: livre.descricao,
      quantidade: 1,
      valorUnitario: livre.valor,
      valorTotal: livre.valor,
      observacao: `Buffet livre — pesado ${formatarPesoKg(gramas / 1000)}`,
    };
  }

  return {
    idProduto: produto.id,
    nome: produto.descricao,
    quantidade: gramas / 1000,
    valorUnitario: produto.valor,
    valorTotal: centavos / 100,
  };
}
